import React from "react";
import styled from "styled-components";

import { ModernBlueButtonLink } from "components/ui/ButtonLink";

import SplashContainer from "components/ui/SplashContainer";
import {
  XLSpacer,
  LargeSpacer,
  MediumSpacer,
} from "components/ui/VerticalSpacers";
import { Footer } from "components/ui/Layout/Footer";

import { SplashPageAlerts } from "components/pages/SplashPage/SplashPageAlerts";
import { SplashPageResourceLinks } from "components/pages/SplashPage/SplashPageResourceLinks";

import logo from "assets/images/calcentral_logo_360x55.svg";
import bayView from "assets/images/uc_berkeley_bay_view.jpg";

export const SplashPage = () => {
  return (
    <SplashStyles data-testid="splash-page">
      <main>
        <SignInTile data-testid="sign-in-tile">
          <MediumSpacer />
          <h1>
            <img src={logo} alt="CalCentral" />
          </h1>
          <LargeSpacer />
          <ModernBlueButtonLink href="/auth/cas" data-testid="sign-in">
            Sign in
          </ModernBlueButtonLink>
          <SplashPageResourceLinks />
        </SignInTile>

        <XLSpacer />
        <SplashPageAlerts />
      </main>

      <Footer />
    </SplashStyles>
  );
};
SplashPage.displayName = "SplashPage";

const SplashStyles = styled.div`
  background-attachment: fixed;
  background-image: url("${bayView}");
  background-repeat: no-repeat;
  background-size: cover;
  min-height: 100vh;
  padding-top: 40px;

  display: flex;
  flex-direction: column;
  align-items: space-between;

  main {
    flex: 1;
  }
`;

const SignInTile = styled(SplashContainer)`
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    max-width: 360px;
  }

  @media only screen and (max-width: 767px) {
    img {
      max-width: 270px;
    }
  }

  a {
    min-width: 200px;
    text-align: center;
  }
`;
